export default __webpack_public_path__ + "static/media/T11.2461353f.JPG";